import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: React.ReactNode;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, label, id, ...props }, ref) => (
    <label
      htmlFor={id}
      className="flex cursor-pointer items-start gap-2 text-sm text-night-blue/80"
    >
      <input
        ref={ref}
        id={id}
        type="checkbox"
        className={cn(
          "mt-0.5 h-4 w-4 rounded border-night-blue/30 text-leaf-green-ink focus:ring-leaf-green",
          className,
        )}
        {...props}
      />
      {label && <span>{label}</span>}
    </label>
  ),
);
Checkbox.displayName = "Checkbox";
